import Skeleton from '@mui/material/Skeleton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

export function LoadingSkeleton() {
  const numberOfSkeletons = 3
  return (
    <List>
      {[...Array(numberOfSkeletons)].map((_, index) => (
        <ListItem key={index}>
          <ListItemIcon>
            <Skeleton variant='rectangular' data-testid='loading-skeleton' width={40} height={40} />
          </ListItemIcon>
          <ListItemText primary={<Skeleton width='60%' />} secondary={<Skeleton width='40%' />} />
        </ListItem>
      ))}
    </List>
  )
}
